import { PREFIXES } from '../../../actionTypePrefixes'

export const FETCH_MUSEUMS_TRIGGER = `${PREFIXES.TRIGGER}:FETCH_MUSEUMS`
export const FETCH_MUSEUMS_REQUEST = `${PREFIXES.REQUEST}:FETCH_MUSEUMS`
export const FETCH_MUSEUMS_SUCCESS = `${PREFIXES.SUCCESS}:FETCH_MUSEUMS`
export const FETCH_MUSEUMS_FAILURE = `${PREFIXES.FAILURE}:FETCH_MUSEUMS`
export const FETCH_MUSEUMS_FULFILL = `${PREFIXES.FULFILL}:FETCH_MUSEUMS`

export const FETCH_STORAGE_LOCATIONS_TRIGGER = `${PREFIXES.TRIGGER}:FETCH_STORAGE_LOCATIONS`
export const FETCH_STORAGE_LOCATIONS_REQUEST = `${PREFIXES.REQUEST}:FETCH_STORAGE_LOCATIONS`
export const FETCH_STORAGE_LOCATIONS_SUCCESS = `${PREFIXES.SUCCESS}:FETCH_STORAGE_LOCATIONS`
export const FETCH_STORAGE_LOCATIONS_FAILURE = `${PREFIXES.FAILURE}:FETCH_STORAGE_LOCATIONS`
export const FETCH_STORAGE_LOCATIONS_FULFILL = `${PREFIXES.FULFILL}:FETCH_STORAGE_LOCATIONS`



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/constants/quote/step02/index.ts